<template>
	<div id="app">
		<div id="Diagnose" class="mx-auto w-full md:max-w-[707px]">
			<template v-if="step == 0">
				<OpeningPage/>
			</template>
			<template v-else>
				<div class="question-wrap">
					<div class="px-2 md:px-0">
						<div class="q-head"><img src="@/assets/img/question/q_head.png"></div>
						<div class="q-body">
							<transition mode="out-in">
								<QuestionCts01 v-if="step == 1" key="1"/>
								<QuestionCts02 v-if="step == 2" key="2"/>
								<QuestionCts03 v-if="step == 3" key="3"/>
								<QuestionCts04 v-if="step == 4" key="4"/>
								<QuestionCts05 v-if="step == 5" key="5"/>
								<QuestionCts06 v-if="step == 6" key="6"/>
								<QuestionCts07 v-if="step == 7" key="7"/>
								<QuestionCts08 v-if="step == 8" key="8"/>
								<QuestionCts09 v-if="step == 9" key="9"/>
								<QuestionCts10 v-if="step == 10" key="10"/>
								<QuestionCts11 v-if="step == 11" key="11"/>
								<ResultCts01 v-if="step == 12" key="12"/>
								<ResultCts02 v-if="step == 13" key="13"/>
								<ResultCts03 v-if="step == 14" key="14"/>
								<ResultCts04 v-if="step == 15" key="15"/>
							</transition>
						</div>
						<div class="q-bottom"><img src="@/assets/img/question/q_bottom.png"></div>
					</div>
				</div>
			</template>
		</div>

	</div>
</template>

<script>
import OpeningPage from './components/OpeningPage.vue'
import QuestionCts01 from './components/question/QuestionCts01.vue'
import QuestionCts02 from './components/question/QuestionCts02.vue'
import QuestionCts03 from './components/question/QuestionCts03.vue'
import QuestionCts04 from './components/question/QuestionCts04.vue'
import QuestionCts05 from './components/question/QuestionCts05.vue'
import QuestionCts06 from './components/question/QuestionCts06.vue'
import QuestionCts07 from './components/question/QuestionCts07.vue'
import QuestionCts08 from './components/question/QuestionCts08.vue'
import QuestionCts09 from './components/question/QuestionCts09.vue'
import QuestionCts10 from './components/question/QuestionCts10.vue'
import QuestionCts11 from './components/question/QuestionCts11.vue'
import ResultCts01 from './components/question/ResultCts01.vue'
import ResultCts02 from './components/question/ResultCts02.vue'
import ResultCts03 from './components/question/ResultCts03.vue'
import ResultCts04 from './components/question/ResultCts04.vue'

export default {
	name: 'App',
	components: {
		OpeningPage,
		QuestionCts01,
		QuestionCts02,
		QuestionCts03,
		QuestionCts04,
		QuestionCts05,
		QuestionCts06,
		QuestionCts07,
		QuestionCts08,
		QuestionCts09,
		QuestionCts10,
		QuestionCts11,
		ResultCts01,
		ResultCts02,
		ResultCts03,
		ResultCts04,
	},
	data() {
		return {
			debugMode: true
		}
	},
	computed: {
		step() {
			return this.$store.getters.step
		},
		history() {
			return this.$store.getters.history
		}
	}
	,
	methods: {
		next(step) {
			this.$store.dispatch('next', step)
		}
	}
}
</script>

<style lang="scss">

#Diagnose {
	/* はじめ */
	.v-enter {
		/* 最初は表示して欲しくないので 0 */
		opacity: 0;
	}
	/* transition している間 */
	.v-enter-active {
		transition: opacity 1.5s
	}
	/* おわり */
	.v-enter-to {
		/* 終わったら表示して欲しいので 1 */
		opacity: 1;
	}
	.slide-fade-enter-active {
		transition: all .6s ease;
	}
	.slide-fade-leave-active {
		transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}
	.slide-fade-enter, .slide-fade-leave-to {
		transform: translateX(10px);
		opacity: 0;
	}
	div.question-wrap {
		div.q-body {
			background-image: url(~@/assets/img/question/q_bg.png);
			background-repeat: repeat-y;
			background-size: contain;
			display: flex;
			justify-content: center;
			min-height: 360px;
			@media screen and (max-width: 480px) {
				min-height: 40vh;
			}
			div.q-cts {
				@media screen and (max-width: 480px) {
					padding: 2em 3em;
				}
				padding: 4em 4.5em 0;
			}
			div.q-text {
				padding: 8px;
				background: #FFF;
				box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1);
				.vue-typer {
					font-family: 'Noto Sans JP', sans-serif;
					font-size: 32px;
					text-shadow: 1px 1px 0 #FFF, -1px -1px 0 #FFF,
					-1px 1px 0 #FFF, 1px -1px 0 #FFF,
					0px 1px 0 #FFF, 0-1px 0 #FFF,
					-1px 0 0 #FFF, 1px 0 0 #FFF;
					text-align: center;
					@media screen and (max-width: 480px) {
						font-size: 1.4rem;
					}
					.custom.caret {
						display: none;
					}
				}
			}
		}
		div.result {
			margin: 0 auto;
			width: 92%;
			div.answer-wrap {
				margin: 0;
				padding: 2rem;
				background-image: url(~@/assets/img/question/result.png);
				background-repeat: no-repeat;
				background-size: cover;
				background-position: bottom;
				min-height: 360px;
				@media screen and (max-width: 480px) {
					margin: 0;
					padding: 1.5rem;
				}
				div.answer-title {
					margin-bottom: 1em;
					font-size: 36px;
					font-weight: bold;
					color: #e15677;
					text-align: center;
					div.text {
						margin-top: 8px;
						font-size: 24px;
						@media screen and (max-width: 480px) {
							font-size: 1.2rem;
						}
					}
					@media screen and (max-width: 480px) {
						font-size: 1.6rem;
					}
				}
				div.answer-body {
					h2 {
						margin-bottom: 12px;
						padding-bottom: 12px;
						border-bottom: dotted 2px #CCC;
						font-weight: bold;
						font-size: 18px;
						color: #e15677;
						@media screen and (max-width: 480px) {
							font-size: 1.2em;
							margin-bottom: 6px;
							padding-bottom: 6px;
						}
					}
					dl {
						dt {
							font-weight: bold;
							color: #333;
						}
						dd {
							margin-bottom: 2em;
						}
					}
					p {
						margin-bottom: 2em;
						font-size: 16px;
					}
					div.sub-cts {
						margin-top: 2em;
						background: #FFF;
						border-radius: 8px;
						padding: 1.5em;
						@media screen and (max-width: 480px) {
							margin-top: 1em;
							padding: 1em;
						}
						p {
							margin-bottom: 0;
							font-size: 16px;
							line-height: 180%;
							@media screen and (max-width: 480px) {
								font-size: 14px;
							}
						}
						ul {
							padding-left: 2em;
							@media screen and (max-width: 480px) {
								padding-left: 1.2em;
							}
							li {
								margin-top: 12px;
								list-style: disc;
								a {
									color: dodgerblue;
									font-size: 16px;
									@media screen and (max-width: 480px) {
										font-size: 14px;
									}
								}
							}
						}
					}
				}
			}
		}
		div.btn-area {
			margin-top: 2em;
			display: flex;
			justify-content: center;
			align-items: center;
			button {
				margin: 4px 8px;
				border-radius: 6px;
				min-height: 48px;
				min-width: 120px;
				color: #FFF;
				max-width: 33%;
				padding: 4px;
				background: #FFF;
				box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1);
				img {
					width: 100%;
					height: auto;
					&:hover {
						opacity: 0.75;
					}
				}
				&.btnReset {
					background: yellow;
					border-radius: 24px;
					color: black;
					border: solid 2px #111;
					font-weight: bold;
				}
			}
		}
	}
}
div.debug-bar {
	button {
		margin: 0 4px;
		padding: 4px 8px;
		background: #CCC;
	}
}

</style>